export default "__VITE_ASSET__7dabd75e__"